import testFile from './100kb.txt'

class BandwidthService {
  constructor() {
    this.kbps = null
  }

  test = () => {
    return new Promise(resolve => {
      let startTime = window.performance.now()
      let xhr = new XMLHttpRequest()

      let onLoaded = response => {
        let kb = response.total * 8 / 1000
        let sec = (window.performance.now() - startTime) / 1000
        this.kbps = Math.round(kb / sec)
        console.log(`BandwidthService ${this.kbps} kbps`)
        resolve(this.kbps)
      }

      xhr.onload = onLoaded
      xhr.open('GET', `${testFile}?${Math.random()}`)

      xhr.send()
    })
  }
}

let service = new BandwidthService()
export default service

window.BandwidthService = service // DEBUG
